import { useCallback, useState } from "react";
import { handleErrorLoadDataResponse } from "../../../@vendor/utils";
import { useTranslation } from "react-i18next";
import AccountRepository from "../../../repositories/AccountRepository";
import { Patient } from "../../../models/Patient";

export const useGetCustomer = () => {
  const { t } = useTranslation();
  const [data, setData] = useState<Patient[]>([]);
  const [isFetching, setIsFetching] = useState<boolean>(false);

  const loadData = useCallback(async () => {
    setIsFetching(true);

    await AccountRepository.patient({
      with: ["photo"],
    })
      .then((response) => {
        const { data: responseData } = response.data;
        setData(responseData);
      })
      .catch(() => {
        handleErrorLoadDataResponse(t, t("notification.error.default"));
      })
      .finally(() => {
        setIsFetching(false);
      });
  }, []);

  return {
    data,
    isFetching,
    loadData,
  };
};
